import GeneralTemplate from '../templates/GeneralTemplate';
import BusTime from '../components/BusTime';
import cover from '../assets/cover/search_bus.jpg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function SearchBus() {
  const bannerProps = {
    imageSrc: cover,
    title: "公車即時動態",
    subtitle: (<>
    <p className="subtitle">請先選擇您的地區，再選擇公車路線
      <OverlayTrigger overlay={<Tooltip id={1}>
      因TDX平台API有次數限制，若已達上限請選擇<br/>
      台北 - [307] 板橋 ↔︎ 撫遠街<br/>
      將使用預存的資料進行展示</Tooltip>}>
        <svg className="error-info bi bi-info-circle-fill" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#7240DB" viewBox="0 0 16 16">
          <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
        </svg>
    </OverlayTrigger>
    <br/>即可顯示相關資訊，例如站點、站序、到站動態等等。</p>
    <p>Please select a city first. Then, choose the bus route you want to inquire about,<br/> and it will display the relevant stop sequence and bus arrival times.</p>
    </>)
  };

  const content = (
    <>
      <BusTime/>
    </>
  );

  return (

    <GeneralTemplate 
      bannerProps={bannerProps} 
      content={content} 
    />
  );
}

export default SearchBus;